import {
  AddMeetingComment_Type,
  Get_All_Leads_For_Managers_By_Managers_Email,
  Get_All_Leads_For_Managers_By_Managers_Email_CRM_DATA,
  Get_All_Leads_For_Role_By_email_MarketerLeads_Type,
  Get_All_Leads_For_Role_By_email_Type,
  Get_All_Leads_For_TeamLeader_By_TeamLeader_Email,
  Get_All_Sales_Managers_By_Email,
  Get_All_Team_Leaders,
  Get_Error,
  Get_sales_dashboard_Advanced,
  Get_TeamLeader_Dashboard_Advanced_crmdata_Type,
  Get_TeamLeader_Dashboard_Advanced_Type,
} from '../Types';

const intial = {
  RolesData: [],
  LeadsForSales: [],
  LeadsForTeamLeader: [],
  LeadsForManagers: [],
  teamleaderdashboard: [],
  teamleaderdashboardcrmdata: [],
  LeadsForManagerscrmdata: [],
  AddMeetingComment: [],
  salesformanagers: [],
  Get_Leads_For_Marketer: [],
  salesdashboard: [],
  loading: true,
};

const DataForRoles_Reducers = (state = intial, action) => {
  switch (action.type) {
    case Get_All_Team_Leaders:
      return {
        ...state,
        RolesData: action.payload,
        loading: false,
      };

    case Get_All_Leads_For_Role_By_email_Type:
      return {
        ...state,
        LeadsForSales: action.payload,
        loading: false,
      };

    case Get_All_Leads_For_TeamLeader_By_TeamLeader_Email:
      return {
        ...state,
        LeadsForTeamLeader: action.payload,
        loading: false,
      };

    case Get_All_Leads_For_Managers_By_Managers_Email:
      return {
        ...state,
        LeadsForManagers: action.payload,
        loading: false,
      };

    case Get_All_Leads_For_Managers_By_Managers_Email_CRM_DATA:
      return {
        ...state,
        LeadsForManagerscrmdata: action.payload,
        loading: false,
      };

    case Get_All_Sales_Managers_By_Email:
      return {
        ...state,
        salesformanagers: action.payload || [],
        loading: false,
      };

    case Get_TeamLeader_Dashboard_Advanced_Type:
      return {
        ...state,
        teamleaderdashboard: action.payload || [],
        loading: false,
      };

    case Get_TeamLeader_Dashboard_Advanced_crmdata_Type:
      return {
        ...state,
        teamleaderdashboardcrmdata: action.payload || [],
        loading: false,
      };

    case Get_All_Leads_For_Role_By_email_MarketerLeads_Type:
      return {
        Get_Leads_For_Marketer: action.payload,
        loading: false,
      };

    case Get_sales_dashboard_Advanced:
      return {
        ...state,
        salesdashboard: action.payload || [],
        loading: false,
      };

    case AddMeetingComment_Type:
      return {
        ...state,
        AddMeetingComment: action.payload || [],
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        RolesData: action.payload,
      };
    default:
      return state;
  }
};

export default DataForRoles_Reducers;
